import { Home } from "./pages/Home";

import "./global.css";

export const App = () => (
  <>
   <Home />
  </>
);
